import {
  FontWeight,
  Heading,
  HeadingVariant,
  LiliButton,
  LiliButtonType,
  LiliOtp,
  Spinner,
  SpinnerColor,
} from '@lili/lili-frontend-common';
import { twMerge } from 'tailwind-merge';
import { useTranslation } from 'react-i18next';
import logoUrl from '@Assets/logos/lili-logo-blue.svg';
import { useResizeListener } from '@Hooks/custom/useResizeListener';
import { useLoginOtpVerificationLogic } from './hooks/useLoginOtpVerificationLogic';

export const LoginOtpVerification = () => {
  const {
    isPending,
    mfaDestination,
    requestMfaCode,
    handleVerifyCode,
    padTimeLeft,
    error,
    clearError,
  } = useLoginOtpVerificationLogic();
  const { t } = useTranslation();
  const { isMobile } = useResizeListener();
  const resendButtonClassName = twMerge(
    isPending || !mfaDestination ? 'text-text-main-disabled' : 'text-text-brand-primary ',
    'font-metric text-[12px] w-fit mx-auto py-0 px-0'
  );

  return (
    <div className='recovery-page-container'>
      <div className='flex flex-col pt-[56px] md:pt-[0px] w-full md:w-[520px] px-[24px] md:px-[42px] items-center'>
        <img src={logoUrl} alt='Lili Logo' className='w-[80px] mb-[32px]' />
        <Heading
          variant={isMobile ? HeadingVariant.H7 : HeadingVariant.H3}
          fontWeight={FontWeight.MEDIUM}
          className='recovery-page-header'>
          {t('recovery.verificationCode.title')}
        </Heading>
        {mfaDestination && !isPending && (
          <Heading.H10
            fontWeight={FontWeight.REGULAR}
            className='text-text-main-secondary w-[300px] text-center mb-[28px]'>
            {t('recovery.verificationCode.subtitle', { mfaDestination })}
          </Heading.H10>
        )}
        {mfaDestination && !isPending && (
          <LiliOtp
            id='security-question'
            onCompleted={(value) => handleVerifyCode(value)}
            maxLength={6}
            onBlur={() => clearError()}
            onFocus={() => clearError()}
            errorMessage={error}
          />
        )}

        {isPending && (
          <div className='mx-auto my-[12px]'>
            <Spinner spinnerColor={SpinnerColor.Blue} height='24px' width='24px' />
          </div>
        )}

        <div className='flex flex-col items-end gap-2 mt-[30px]'>
          {!padTimeLeft && (
            <Heading.H12 fontWeight={FontWeight.SEMIBOLD} className='text-text-main-secondary'>
              {t('recovery.verificationCode.stillHavenTReceivedCode')}
            </Heading.H12>
          )}
          {padTimeLeft && (
            <div className='flex items-center justify-center w-full gap-1'>
              <Heading.H12 fontWeight={FontWeight.REGULAR} className='text-text-main-secondary'>
                {t('recovery.verificationCode.resendCodeIn')}
              </Heading.H12>
              <Heading.H12 fontWeight={FontWeight.REGULAR} className='text-text-brand-primary'>
                {padTimeLeft}
              </Heading.H12>
            </div>
          )}
          {!padTimeLeft && (
            <LiliButton
              disabled={isPending || !mfaDestination}
              id='login-button'
              className={resendButtonClassName}
              onClick={requestMfaCode}
              title={t('recovery.verificationCode.resendCode')}
              type={LiliButtonType.SKIP}
            />
          )}
        </div>
      </div>
      <Heading.H12
        fontWeight={FontWeight.REGULAR}
        className='text-text-main-secondary text-center absolute bottom-[48px] left-[50%] translate-x-[-50%] w-[376px]'>
        {t('recovery.verificationCode.disclaimer')}
      </Heading.H12>
    </div>
  );
};
